<template>
  <div class="bThanks">
    <div
      v-if="!authStore.isPartner"
      class="bThanks__card"
    >
      <div class="descWrapper">
        <div
          :class="[
            'app__title app__title--h4 color--grayTone3',
            partnerStore?.partner?.is_manufacturer_page ? 'font-samsung-sharp' : 'font-poppins'
          ]"
        >
          {{ t('buyout.thank_you.common_user.thanks') }} 🎉
        </div>
        <div :class="['app__title', partnerStore?.partner?.is_manufacturer_page ? 'font-samsung-sharp' : '']">
          {{ t('buyout.thank_you.common_user.success_buyout_text') }}
        </div>
        <div :class="['desc', partnerStore?.partner?.is_manufacturer_page ? 'font-samsung-one' : '']">
          {{ t('buyout.thank_you.common_user.order_confirm_text') }}
          <br>
          {{ t('buyout.thank_you.common_user.order_confirm_text2') }}
        </div>
        <v-btn
          :class="['mbtn', partnerStore?.partner?.is_manufacturer_page ? 'mbtn--black' : 'mbtn--green']"
          size="x-large"
          :to="localePath({name: 'buyout-detail-id', params: {id: userBuyoutCode ? userBuyoutCode : ''}})"
        >
          {{ t('buyout.thank_you.common_user.order_detail') }}
        </v-btn>
      </div>
      <div
        v-if="lgAndUp"
        class="imgWrapper"
      >
        <img
          v-if="customImagePath"
          :src="customImagePath"
          :alt="t('buyout.thank_you.common_user.success_buyout_text')"
          class="img-responsive"
          style="border-radius: 15px"
        >
        <img
          v-else
          src="~/assets/media/lady-cashtec-thanks.png"
          :alt="t('buyout.thank_you.common_user.success_buyout_text')"
          class="img-responsive"
        >
      </div>
    </div>
    <div
      v-if="authStore.isPartner"
      class="bThanks__card"
    >
      <div class="descWrapper">
        <div class="app__title app__title--h4 font-poppins color--grayTone3">
          {{ t('buyout.thank_you.common_user.thanks') }} 🎉
        </div>
        <div class="app__title">
          {{ t('buyout.thank_you.ambassador_partner.success_buyout_text') }}
        </div>
        <div class="desc">
          {{ t('buyout.thank_you.ambassador_partner.order_confirm_text') }}
          <span class="font-weight-semibold">{{ clientEmail }}</span>
        </div>
        <v-btn
          class="mbtn mbtn--green"
          size="x-large"
          :to="localePath({name: 'index'})"
        >
          {{ t('buyout.thank_you.ambassador_partner.close') }}
        </v-btn>
      </div>
      <div
        v-if="lgAndUp"
        class="imgWrapper"
      >
        <img
          src="~/assets/media/lady-cashtec-thanks.png"
          :alt="t('buyout.thank_you.ambassador_partner.success_buyout_text')"
          class="img-responsive"
        >
      </div>
    </div>
    <buyout-buyout-detail-account-activation-window v-if="!authStore.isLoggedIn && !accountAlreadyExists" :additional-inputs="false" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";

withDefaults(defineProps<{
  customImagePath?: string | null
}>(), {
  customImagePath: null,
});

const { lgAndUp } = useDisplay();

const authStore = useAuthStore();
const partnerStore = usePartnerStore();
const buyoutStore = useBuyoutStore();
const localePath = useLocalePath();
const { t } = useI18n();

const {
  clientEmail,
  userBuyoutCode,
  accountAlreadyExists
} = storeToRefs(buyoutStore);

</script>
